import { FC } from "react";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import * as Styled from "./PersonAccordionTitle.styled";

type PersonAccordionTitleProps = {
    name: string;
    birthDate: string;
    role: string;
};

export const PersonAccordionTitle: FC<PersonAccordionTitleProps> = ({ name, birthDate, role }) => {
    const { t } = useTypedTranslation();

    return (
        <Styled.PersonTitleWrapperBox>
            <Styled.PersonTitleHeadingXS>{name}</Styled.PersonTitleHeadingXS>
            <Styled.PersonTitleStack>
                <Styled.PersonTitleVaue>
                    {t("global.birthDate")} {birthDate}
                </Styled.PersonTitleVaue>

                <Styled.PersonTitleValueDivider orientation="vertical" flexItem />

                <Styled.PersonTitleVaue>{role}</Styled.PersonTitleVaue>
            </Styled.PersonTitleStack>
        </Styled.PersonTitleWrapperBox>
    );
};
